/* AggregatorEditor.js */

"use strict";

/**
 * @type {uiCoreTools}
 */
const uiCore = require("@gluenetworks/steve_ui_core");
// const { typeLabelsList, getTypeData, typeDataByLabel } = require("../CustomFieldsConstants");
const CommonEditor = require("./CommonEditor");

const SingleComboBoxControl = uiCore.Control.OptionSelection.Single.ComboBox;

class AggregatorEditor extends CommonEditor {
    constructor(args) {
        super(args);
        this.rootElement.classList.add("select");
        this.rootElement.classList.add("aggregator-editor");
        this._grid = args.grid;
    }

    applyValue(item, state) {
        // console.log(item, state);
        super.applyValue(item, state);
        if (!state) {
            Object.assign(item, { aggregator: undefined });
        } else {
            Object.assign(item, { aggregator: state });
        }
    }

    /**
     *
     * @returns {ComboBoxControlComponent}
     * @private
     */
    _createInput() {
        const combobox = new SingleComboBoxControl({
            showFilter: false,
            darkTheme: false,
            adjustWidth: true,
            allowClear: false
        });
        combobox.setOptions([
            {
                label: "Sum",
                value: "sum"
            },
            {
                label: "Average",
                value: "average"
            },
            {
                label: "None",
                value: ""
            }
        ]);
        return combobox;
    }
}

module.exports = AggregatorEditor;
